import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-74925ff7")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")

  return (!_ctx.isTitle)
    ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        placement: _ctx.placement,
        "popper-class": "component_text-tip"
      }, {
        content: _withId(() => [
          (_ctx.$slots.content)
            ? _renderSlot(_ctx.$slots, "content", { key: 0 }, undefined, true)
            : (_openBlock(), _createBlock("div", {
                key: 1,
                class: "tip-wrap",
                style: { maxWidth: _ctx.tipWidth + 'px' }
              }, _toDisplayString(_ctx.content), 5))
        ]),
        default: _withId(() => [
          _createVNode("div", {
            class: "omit-wrap",
            style: _ctx.breakAll ? 'word-break: break-all' : ''
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true),
            _createTextVNode(" " + _toDisplayString(_ctx.$slots.default ? '' : _ctx.content), 1)
          ], 4)
        ]),
        _: 3
      }, 8, ["placement"]))
    : (_openBlock(), _createBlock("div", {
        key: 1,
        title: _ctx.content
      }, [
        _createVNode("div", {
          class: "omit-wrap",
          style: _ctx.breakAll ? 'word-break: break-all' : ''
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          _createTextVNode(" " + _toDisplayString(_ctx.$slots.default ? '' : _ctx.content), 1)
        ], 4)
      ], 8, ["title"]))
})